let Menu          = require('../components/Menu');
let MenuVertical  = require('../components/MenuVertical');
let Mouse         = require('../components/Mouse');
let ShowMore      = require('../modules/ShowMore');
let Chronological = require('../partials/Chronological');
let Project       = require('../partials/Project');
let News          = require('../partials/News');
let Gallery       = require('../partials/Gallery');
let OnePage       = require('../components/OnePage');

class Homepage {
    constructor() {
        new Menu('js-anchor').init(true);
        let menuVertical = new MenuVertical();
        menuVertical.init();
        new Mouse(menuVertical.getLinks());
        new OnePage();
        new ShowMore();
        new Chronological();
        new Project();
        new News();
        new Gallery();
    }
}

module.exports = Homepage;